export enum EnumLoanStatus {
	NON_IN_PRESTITO = "A",
	IN_PRESTITO = "B",
	IN_ATTESA = "F",
}
